import classes from "./FoldersView.module.css";
import FoldersList from "./list/FoldersList";

/**
 * Shows folders.
 * Part of navbar.
 * @constructor
 * @author Kacper Faber
 * @since 0.1.7
 */
function FoldersView() {
    return (
        <div className={classes.root}>
            <div className={classes.title}>
                FOLDERY
            </div>

            <FoldersList
                withCreateButton
            />
        </div>
    );
}

// noinspection JSUnusedGlobalSymbols
export default FoldersView;